import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesTracksState = typeof INITIAL_STATE;

// TRACKS ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS]: saveTrackData,
});

// CASE FUNCTIONS
function saveTrackData(state: EntitiesTracksState, action: $TSFixMe): EntitiesTracksState {
  const newState = state.mergeDeep(action.response.entities.tracks);
  return newState;
}
